export default __webpack_public_path__ + "static/media/Vector0.02805746.svg";